//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.CurveLimitsData.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitOptions.js";
import "../no/SelectDisplayableObject.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"AngleTolerance",1,0],[0,"ArcCenterPoint",1,"Point",0],[1,"ArcDiameter",0,"Expression",0],[0,"ArcEndOption",1,0],[0,"ArcEndPoint",1,"Point",0],[1,"ArcLimits",0,"GeometricUtilities.CurveLimitsData",0],[0,"ArcMethod",1,0],[0,"ArcMidOption",1,0],[0,"ArcMidPoint",1,"Point",0],[1,"ArcRadius",0,"Expression",0],[0,"ArcStartPoint",1,"Point",0],[0,"ArcThroughOption",1,0],[0,"ArcThroughPoint",1,"Point",0],[0,"AssociativeToggle",1,0],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"CurveFitProperties",0,"GeometricUtilities.CurveFitOptions",0],[0,"CurveType",1,0],[0,"DistanceTolerance",1,0],[1,"EndAngle",0,"Expression",0],[1,"EndAtAngle",0,"SelectDisplayableObject",0],[1,"Faces",0,"ScCollector",0],[0,"IsPeriodic",1,0],[0,"LineEndOption",1,0],[1,"LineLimits",0,"GeometricUtilities.CurveLimitsData",0],[0,"ModeOption",1,0],[0,"SpecifyEndPoint",1,"Point",0],[0,"SpecifyEndVector",1,"Direction",0],[0,"SpecifyStartPoint",1,"Point",0]],[],[]];
SPLM.Features.CurveOnSurfaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CurveOnSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.CurveOnSurfaceBuilder.CurveTypeEnum = Object.freeze({
    "Spline" : "Spline", "Line" : "Line", "ArcCircle" : "ArcCircle", "Conic" : "Conic"});

SPLM.Features.CurveOnSurfaceBuilder.ModeOptionEnum = Object.freeze({
    "Projection" : "Projection", "Geodesic" : "Geodesic"});

SPLM.Features.CurveOnSurfaceBuilder.LineEndOptionEnum = Object.freeze({
    "Point" : "Point", "AtAngle" : "AtAngle", "AlongXC" : "AlongXC", "AlongYC" : "AlongYC", "AlongZC" : "AlongZC", "AlongVector" : "AlongVector"});

SPLM.Features.CurveOnSurfaceBuilder.ArcMethodEnum = Object.freeze({
    "FromCenter" : "FromCenter", "ThreePoints" : "ThreePoints"});

SPLM.Features.CurveOnSurfaceBuilder.ArcThroughOptionEnum = Object.freeze({
    "Point" : "Point", "Radius" : "Radius", "Diameter" : "Diameter"});

SPLM.Features.CurveOnSurfaceBuilder.ArcEndOptionEnum = Object.freeze({
    "Point" : "Point", "Radius" : "Radius", "Diameter" : "Diameter"});

SPLM.Features.CurveOnSurfaceBuilder.ArcMidOptionEnum = Object.freeze({
    "Point" : "Point", "Radius" : "Radius", "Diameter" : "Diameter"});

export default SPLM;